import { render, staticRenderFns } from "./Sidebar.component.vue?vue&type=template&id=77c81e9d&scoped=true"
import script from "./Sidebar.component.vue?vue&type=script&lang=js"
export * from "./Sidebar.component.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.component.vue?vue&type=style&index=0&id=77c81e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c81e9d",
  null
  
)

export default component.exports